// The content area for a URL no route matches. The SWA fallback still serves it
// with HTTP 200: staticwebapp.config.json is out of scope (ADR 0001).
const NotFoundPage = () => (
  <div className="row second">
    <div className="large-12 columns" style={{ paddingLeft: "0.3em" }}>
      <h1>Page Not Found</h1>
      <p>
        The page you were looking for isn't here. It may have moved, or the link may be out of date. Try the{" "}
        <a href="/">home page</a>, or use the menu above.
      </p>
    </div>
  </div>
);

export default NotFoundPage;
